import * as React from 'react';

import PropTypes from 'prop-types';

export class IntegerStat extends React.Component {
    static propTypes = {
        value: PropTypes.shape({
            value: PropTypes.number.isRequired,
            prefix: PropTypes.string.isRequired,
            suffix: PropTypes.string.isRequired,
            formatted: PropTypes.string.isRequired,
        }).isRequired,
    };

    render() {
        if (!this.props.value) {
            return null;
        }

        // We can only fit 8 digits!
        const isRawValueTooLong = this.props.value.value > 99999999;
        const displayedValue = isRawValueTooLong
            ? this.props.value.formatted
            : Number(this.props.value.value).toLocaleString();

        return (
            <div>
                <span>{this.props.value.prefix}</span>
                <span>{displayedValue}</span>
                {isRawValueTooLong ? <span>{this.props.value.suffix}</span> : undefined}
            </div>
        );
    }
}
